import React, { useState, useEffect } from "react";
import { FaSearch } from "react-icons/fa";
import { getAllMedicalCertificate } from "../../../store/slices/medicalCertificate.slice";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import classNames from "classnames";
import styles from "./medicalCertificate.module.scss";
import Table from "../../common/Table/table";
import moment from "moment";

const MedicalCertificate = () => {
  const [searchValue, setSearchValue] = useState("");
  const [reportFromData, setReportFromData] = useState({
    fromDate: "",
    toDate: "",
  });
  const { clinicInfo } = useSelector((state) => state.clinic);
  const { token } = useSelector((state) => state.auth);
  const { medicalCertificate, searchMessage, loading } = useSelector(
    (state) => state.medicalCertificate,
  );
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const clinicId = clinicInfo?.[0]?.clinicId || null;
  useEffect(() => {
    dispatch(getAllMedicalCertificate({ clinicId, token }));
  }, [dispatch, clinicId, token]);

  const handleShowGlobalViewModal = (item) => {
    sessionStorage.setItem("medicalCertificateId", item.id);
    sessionStorage.setItem("patientId", item?.patientId);
    sessionStorage.setItem("appointmentId", item?.appointmentId);
    navigate("/viewMedicalCertificate", { state: { reportData: item } });
  };

  const handleEditLabReport = (id) => {
    sessionStorage.setItem("medicalCertificateId", id.id);
    navigate("/editMedicalCertificate");
  };

  const tableHead = [
    { title: "APT Id", key: "appointmentId" },
    { title: "Patient Name", key: "name" },
    { title: "Certificate Status", key: "certificateStatus" },
    { title: "Appt Date", key: "appointmentDate" },
  ];

  const handleFilter = async () => {
    if (reportFromData.fromDate && reportFromData.toDate) {
      await dispatch(
        getAllMedicalCertificate({
          clinicId,
          fromDate: reportFromData.fromDate,
          toDate: reportFromData.toDate,
          token,
        }),
      );
    }
  };

  const handleSearch = async (e) => {
    setSearchValue(e.target.value);
    await dispatch(
      getAllMedicalCertificate({
        clinicId,
        searchQuery: e.target.value,
        token,
      }),
    );
  };

  const handleClear = async () => {
    setReportFromData({ fromDate: "", toDate: "" });
    await dispatch(getAllMedicalCertificate({ clinicId, token }));
  };

  return (
    <>
      <div className="row d-flex align-items-center">
        <div className="col-md-3">
          <div className="form-group form-focus focused">
            <label className="focus-label">From</label>
            <div className="cal-icon">
              <input
                className="form-control floating datetimepicker"
                type="date"
                value={reportFromData.fromDate}
                onChange={(e) =>
                  setReportFromData({
                    ...reportFromData,
                    fromDate: e.target.value,
                  })
                }
              />
            </div>
          </div>
        </div>
        <div className="col-md-3">
          <div className="form-group form-focus focused">
            <label className="focus-label">To</label>
            <div className="cal-icon">
              <input
                className="form-control floating datetimepicker"
                type="date"
                value={reportFromData.toDate}
                onChange={(e) =>
                  setReportFromData({
                    ...reportFromData,
                    toDate: e.target.value,
                  })
                }
              />
            </div>
          </div>
        </div>
        <div className="col-md-3">
          <button
            className="btn btn-primary mt-3"
            onClick={() => handleFilter()}
          >
            Filter
          </button>
          <button className="btn btn-danger mt-3 ms-3" onClick={handleClear}>
            Clear
          </button>
        </div>
        <div className={classNames("col-md-3", "mt-4", styles["search-area"])}>
          <input
            type="text"
            className={classNames("form-control", styles["search-input"])}
            placeholder="Search here"
            onChange={(e) => handleSearch(e)}
          />
          <div className="input-group-append">
            <FaSearch className="flaticon-381-search-2" />
          </div>
        </div>
      </div>
      <Table
        tableHead={tableHead}
        tableBody={
          medicalCertificate &&
          (medicalCertificate?.map((item) => ({
            ...item, 
            id: item._id,
            appointmentId: item.appointmentId,
            name: item?.patientId?.userId?.name || "N/A",
            referredBy: item.referredBy?.name || "Self",

            certificateStatus: item?.certificateStatus,
            appointmentDate: moment(item?.appDate).format("DD-MM-YY"),
            reportType: "allReports",
          })) ||
            [])
        }
        addModal
        handleEdit={handleEditLabReport}
        handleShowGlobalViewModal={handleShowGlobalViewModal}
        errorMessage={searchMessage}
        searchValue={searchValue}
        filterDateForSearch={reportFromData.fromDate || reportFromData.toDate}
        isLoading={loading}
      />
    </>
  );
};

export default MedicalCertificate;
